import { formatMoney, formatNumber, parseNumber } from '@/platform/lib/utils';
import {
    Button,
    Dropdown,
    FormGroup,
    Input,
    InputPlaceholder,
    Segment,
    SegmentContent,
} from '@/platform/ui';
import { TrashIcon } from '@heroicons/react/24/outline';
import { Deferred, usePage } from '@inertiajs/react';

const Line = ({ line, onChange, onDelete }) => {
    const { categories } = usePage().props;

    // Reformat the amount as money when the field is blurred
    const amountChange = () => {
        onChange(line.id, 'amount', formatNumber(line?.amount));
    };

    return (
        <Segment>
            <SegmentContent className='grid grid-cols-[1fr_auto] items-end gap-4'>
                <FormGroup inline equal>
                    <Dropdown
                        options={[
                            {
                                id: 'fixed',
                                name: 'Vast bedrag',
                            },
                            { id: 'fee', name: 'Fee' },
                            {
                                id: 'rate',
                                name: 'Uren',
                            },
                            {
                                id: 'scale',
                                name: 'Staffel',
                            },
                            {
                                id: 'payroll',
                                name: 'Stroken',
                            },
                        ]}
                        value={line?.type || ''}
                        onChange={value => onChange(line.id, 'type', value)}
                    />
                    <Deferred
                        data='categories'
                        fallback={<InputPlaceholder placeholder='Categorie' />}
                    >
                        <Dropdown
                            options={categories?.map(category => ({
                                id: category,
                                name: category,
                            }))}
                            value={line?.category || ''}
                            onChange={value =>
                                onChange(line.id, 'category', value)
                            }
                        />
                    </Deferred>
                    <Input
                        placeholder='Omschrijving'
                        value={line?.description || ''}
                        onChange={event =>
                            onChange(line.id, 'description', event.target.value)
                        }
                    />
                    {line?.type === 'rate' && (
                        <Input
                            placeholder='Uren'
                            type='number'
                            value={line?.extra || ''}
                            onChange={event =>
                                onChange(line.id, 'extra', event.target.value)
                            }
                        />
                    )}
                    {line?.type === 'payroll' && (
                        <Input
                            placeholder='Aantal'
                            type='number'
                            value={line?.extra || ''}
                            onChange={event =>
                                onChange(line.id, 'extra', event.target.value)
                            }
                        />
                    )}
                    <Input
                        // label={{ basic: true, content: '€' }}
                        placeholder='Bedrag'
                        value={line?.amount || ''}
                        onChange={event =>
                            onChange(line.id, 'amount', event.target.value)
                        }
                        onBlur={amountChange}
                    />
                    {['fee', 'scale']?.includes(line?.type) && (
                        <>
                            <Input
                                placeholder='Fee'
                                value={line?.extra || ''}
                                onChange={event =>
                                    onChange(
                                        line.id,
                                        'extra',
                                        event.target.value
                                    )
                                }
                            />
                            <div className='text-xs'>
                                Resultaat VCSW
                                <p className='font-bold'>
                                    {formatMoney(
                                        ((line?.extra || 0) / 100) *
                                            (parseNumber(line?.amount) || 0)
                                    )}
                                </p>
                            </div>
                        </>
                    )}
                </FormGroup>
                <Button
                    variant='danger'
                    type='button'
                    onClick={() => onDelete(line.id)}
                    aria-label='Verwijder regel'
                >
                    <TrashIcon className='size-5' />
                </Button>
            </SegmentContent>
        </Segment>
    );
};

export default Line;
